import {
  PDFDownloadLink, Document, Page, Text, View, StyleSheet, Link, Font, Image
} from '@react-pdf/renderer'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'


import { normalizeDurationTime } from '../../api/utils'
import Loading from '../Loading'

Font.register({ family: 'StolzlMedium', src: '/static/fonts/stolzl-medium.ttf' })
Font.register({ family: 'StolzlLight', src: '/static/fonts/stolzl-light.ttf' })

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: 'white'
  },
  link: {
    fontFamily: 'StolzlMedium',
    fontSize: 11,
    textDecoration: 'underline',
    letterSpacing: 0,
    color: '#933ec5',
    marginTop: 10
  },
  textFont: {
    fontFamily: 'StolzlMedium',
    letterSpacing: 0
  },
  section: {
    margin: 10,
    padding: 10
  },
  listSection: {
    height: '100%',
    marginLeft: 'auto'
  },
  widget: {
    position: 'relative',
    flexDirection: 'row',
    width: 455,
    height: 150
  },
  background: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    height: '100%'
  },
  star: {
    width: 40,
    height: 40
  },
  info: {
    width: 210,
    letterSpacing: 2
  },
  time: {
    fontFamily: 'StolzlMedium',
    fontSize: 15,
    textTransform: 'uppercase',
    marginBottom: 10,
    width: 200,
    height: 20
  },
  place: {
    fontFamily: 'StolzlLight',
    fontSize: 14,
    width: 200,
    height: 20
  },
  photo: {
    width: 90,
    height: 90,
    borderRadius: 6,
    objectFit: 'cover'
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 100,
    width: 370,
    marginLeft: 65,
    marginTop: 19,
    justifyContent: 'space-between'
  },
  widgetWrapper: {
    width: 510,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  firstLine: {
    height: '50%',
    marginTop: 78,
    marginLeft: 9,
    width: 2,
    backgroundColor: '#d2dae4',
    position: 'absolute'
  },
  midLine: {
    height: 170,
    marginLeft: 9,
    width: 2,
    backgroundColor: '#d2dae4',
    position: 'absolute'
  },
  lastLine: {
    height: 72,
    marginBottom: 88,
    marginLeft: 9,
    width: 2,
    backgroundColor: '#d2dae4',
    position: 'absolute'
  },
  dot: {
    marginTop: 65,
    height: 20,
    width: 20,
    objectFit: 'contain'
  }
})

export default class PDFButton extends Component {
  static propTypes = {
    program: PropTypes.instanceOf(Object),
    className: PropTypes.string
  }

  static defaultProps = {
    program: {},
    className: ''
  }

  state = {
    loading: true
  }

  createDocument = () => {
    const { program: { performances }, program } = this.props
    return (
      <Document onRender={() => { this.state.loading = false }}>
        <Page size="A4" style={styles.page}>
          <View style={styles.section}>
            <Text style={styles.textFont}>Ссылка на программу:</Text>
            <Link style={styles.link}>{`${window.location.origin}/program/profile/${program.id}`}</Link>
          </View>
          <View style={styles.listSection}>
            {performances.map(({
              start_datetime, end_datetime, artist, place, id
            }, i) => (
              <View style={styles.widgetWrapper} key={id}>
                <Image
                  src={`/static/images/${
                    (i === 0 || i === performances.length - 1) ? 'filled-dot' : 'dot'}.png`}
                  style={styles.dot}
                />
                {i === 0 && <View style={styles.firstLine} />}
                {(i !== 0 && i !== performances.length - 1) && <View style={styles.midLine} />}
                {i === performances.length - 1 && <View style={styles.lastLine} />}
                <View style={styles.widget}>
                  <Image src="/static/images/widget.png" style={styles.background} />
                  <View style={styles.content}>
                    <Image src="/static/images/star@2x.png" style={styles.star} />
                    <View style={styles.info}>
                      <Text style={styles.time}>{normalizeDurationTime(start_datetime, end_datetime)}</Text>
                      <Text style={styles.time}>{artist.name}</Text>
                      <Text style={styles.place}>{place.name}</Text>
                    </View>
                    <Image
                      src={artist.photo || '/static/images/artist-placeholder@2x.png'}
                      style={styles.photo}
                      cache
                    />
                  </View>
                </View>
              </View>
            ))}
          </View>
        </Page>
      </Document>
    )
  }

  shouldComponentUpdate() {
    return !this.state.loading
  }

  render() {
    const { className } = this.props

    return (
      <div className={`downloadWrapper ${className}`}>
        <PDFDownloadLink document={this.createDocument()} fileName="program.pdf">
          {({ loading }) => (loading ? <Loading className="margin" /> : <ReactSVG src="/static/images/pdf.svg" />)}
        </PDFDownloadLink>
      </div>
    )
  }
}
